import { useLocation, Navigate } from "react-router-dom";

export function useForgotPasswordFlow() {
  const location = useLocation();
  
  // Check if user is coming from forgot password page with proper state
  const hasValidState = () => {
    const email = localStorage.getItem('reset_email');
    const hasNavigationState = location.state?.email || location.state?.purpose;
    
    return !!(email || hasNavigationState);
  };

  // Check if user navigated directly from forgot password
  const cameFromForgotPassword = () => {
    return location.state?.fromForgotPassword === true;
  };

  return { hasValidState, cameFromForgotPassword };
}

// Guard for EmailVerify page - STRICT version
export function EmailVerifyGuard({ children }) {
  const { hasValidState, cameFromForgotPassword } = useForgotPasswordFlow();
  
  // Only allow access if user came directly from forgot password page
  if (!cameFromForgotPassword() && !hasValidState()) {
    return <Navigate to="/forgot-password" replace />;
  }
  
  return children;
}

// Guard for CreatePassword page
export function CreatePasswordGuard({ children }) {
  const { hasValidState } = useForgotPasswordFlow();
  const location = useLocation();
  
  // Additional check for CreatePassword - needs OTP verification state
  const hasOTPVerified = location.state?.otp || localStorage.getItem('otp_verified');
  
  if (!hasValidState() || !hasOTPVerified) {
    return <Navigate to="/forgot-password" replace />;
  }
  
  return children;
}